<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>Type(s) de sol</th>
          <th class="has-tooltip" v-tooltip="{ content : getTooltipMessage('rdt') }"><span>Rendement potentiel (quintaux / ha)</span></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for='typeSol in sols' :key='typeSol.id_ref_type_sol'>
          <td><div>{{ typeSol.nom }}</div></td>
          <td>
            <v-field-integer v-validate='{ required : true , min_value : 0 }' v-model='typeSol.rendement' :name='typeSol.id_ref_type_sol + "_rdt"' data-vv-as='rendement'/>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import mixinTooltip from '@/mixins/tooltip'

export default {
  name: 'SolCultureTable',
  inject: ['$validator'],
  mixins: [mixinTooltip],

  props: {
    sols: {
      type: Array,
      required: true
    }
  }

}
</script>
